(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const mobileHeader =
      document.querySelector('.header-simple-mobile [data-site-header]') ||
      document.querySelector('.header-mobile [data-site-header]');
    const desktopHeader = document.querySelector('.header-desktop[data-site-header]');
    const mq = window.matchMedia('(min-width: 768px)');

    function setHeaderHeight() {
      const header = mq.matches ? desktopHeader : mobileHeader;
      if (!header) return;

      const height = Math.round(header.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    // Run immediately when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setHeaderHeight);
    } else {
      setHeaderHeight();
    }

    window.addEventListener('resize', setHeaderHeight);

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(setHeaderHeight);
      if (mobileHeader) observer.observe(mobileHeader);
      if (desktopHeader) observer.observe(desktopHeader);
    }

    // Custom search clear: native WebKit cancel is hidden via CSS; this wires our button.
    function bindHeaderSearchClear() {
      document.querySelectorAll('[data-header-search-input]').forEach((input) => {
        // Avoid double-binding if this section script re-runs.
        if (input.dataset.searchClearBound === 'true') return;
        const clearBtn = input.parentElement && input.parentElement.querySelector('[data-header-search-clear]');
        if (!clearBtn) return;
        input.dataset.searchClearBound = 'true';

        // Show the X only when the field has text.
        function syncClear() {
          clearBtn.hidden = input.value.length === 0;
        }

        input.addEventListener('input', syncClear);
        input.addEventListener('change', syncClear);
        syncClear();

        clearBtn.addEventListener('click', (event) => {
          event.preventDefault();
          input.value = '';
          syncClear();
          input.focus();
          // Notify anything else listening for search input changes.
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });
    }

    // Shopify section JS is deferred; bind once the DOM is ready.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindHeaderSearchClear);
    } else {
      bindHeaderSearchClear();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-sell-section]');
    if (!root) return;

    var stats = root.querySelector('[data-sell-stats]');
    if (!stats) return;

    var counters = stats.querySelectorAll('[data-countup]');
    if (!counters.length) return;

    function animate(el) {
      var target = parseFloat(el.getAttribute('data-target')) || 0;
      var prefix = el.getAttribute('data-prefix') || '';
      var suffix = el.getAttribute('data-suffix') || '';
      var decimals = parseInt(el.getAttribute('data-decimals'), 10) || 0;
      var duration = 1400;
      var startTime = null;

      function step(now) {
        if (startTime === null) startTime = now;
        var progress = Math.min((now - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = prefix + target.toFixed(decimals) + suffix;
        }
      }

      requestAnimationFrame(step);
    }

    function run() {
      counters.forEach(animate);
    }

    if (!('IntersectionObserver' in window)) {
      run();
    } else {
      var hasRun = false;
      var statsObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !hasRun) {
              hasRun = true;
              run();
              statsObserver.disconnect();
            }
          });
        },
        { threshold: 0.4 }
      );
      statsObserver.observe(stats);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
